import React from 'react';
import OnboardingContainer from "../OnboardingContainer";
import { ToggleCard } from "../../../Components/Card/ToggleCard";
import AttendedOnboardingsContainer from "../AttendedOnboardingsContainer";
const OnboardingTestContainer = () => {
    
    const options = [
        {
            title: 'educations.onboarding',
            content: <OnboardingContainer />
        },
        {
            title: 'educations.attendededucations',
            content: <AttendedOnboardingsContainer />
        }
    ];
    
    return (<ToggleCard title={'educations.onboarding'} options={options} />
    );
};

export default OnboardingTestContainer;
